var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("保单号")) + ":" + _vm._s(_vm.policyInfo.policyNo))]), _c("div", [_vm._v(_vm._s(_vm.$t("产品名称")) + ":" + _vm._s(_vm.policyInfo.insuranceName))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单状态")) + ":" + _vm._s(_vm.$t(_vm.policyInfo.policyStatus)))]), _c("div", [_vm._v(_vm._s(_vm.$t("生效日期")) + ":" + _vm._s(_vm.policyInfo.startAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("终止日期")) + ":" + _vm._s(_vm.policyInfo.endAt))])]), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔单信息")))])]), _c("a-form-model", {
    attrs: {
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔类型")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.claimsInfo.claimsTypeName,
      callback: function ($$v) {
        _vm.$set(_vm.claimsInfo, "claimsTypeName", $$v);
      },
      expression: "claimsInfo.claimsTypeName"
    }
  })], 1), _c("a-alert", {
    attrs: {
      message: "*" + _vm.$t("请确认根据指引提交相应理赔材料。"),
      banner: ""
    }
  }), _vm._l(_vm.claimsInfo.claimsSort, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "nameBox"
    }, [_vm._v(_vm._s(item.sortName))]), _vm._l(item.claimsParam, function (item2, index2) {
      return _c("a-form-item", {
        key: index2,
        attrs: {
          label: item2.paramName,
          "validate-status": item2.auditOpinion ? "error" : "validating",
          help: item2.auditOpinion ? item2.auditOpinion : ""
        }
      }, [item2.paramType == "text" ? _c("a-input", {
        attrs: {
          placeholder: _vm.$t("请填写") + item2.paramName
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }) : _vm._e(), item2.paramType == "time" ? _c("a-date-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          allowClear: "",
          format: _vm.getFormatDate(),
          placeholder: _vm.$t("请选择") + item2.paramName
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }) : _vm._e(), item2.paramType == "dropDownBox" ? _c("a-select", {
        attrs: {
          placeholder: _vm.$t("请选择") + item2.paramName,
          showSearch: true
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }, _vm._l(item2.selectarr, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3.key
          }
        }, [_vm._v(" " + _vm._s(item3.vaule) + " ")]);
      }), 1) : _vm._e(), item2.paramType == "dropDownBox(region)" ? _c("area-select", {
        attrs: {
          index: index,
          index2: index2,
          defaultValue: _vm.getCityCode(item2.paramPlaceholder)
        },
        on: {
          change: _vm.selectArea
        }
      }) : _vm._e()], 1);
    })], 2);
  })], 2), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔资料")))])]), _vm.claimsInfo.claimsDocument ? _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_vm._l(_vm.claimsInfo.claimsDocument, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      attrs: {
        label: _vm.$t(item.documentName)
      }
    }, [_c("a-upload", {
      staticClass: "upload-list-inline",
      attrs: {
        action: _vm.action,
        accept: _vm.uploadAccept,
        remove: file => _vm.removeUploadFile(file, index),
        "open-file-dialog-on-click": _vm.fileDialog,
        "file-list": item.documentUrl,
        "list-type": "picture-card",
        data: {
          module: "claims"
        },
        showUploadList: {
          showPreviewIcon: true,
          showRemoveIcon: true
        },
        headers: {
          "X-Dispatch": "Upload",
          "X-Version": "upload"
        }
      },
      on: {
        preview: file => _vm.handlePreview(file, index),
        change: file => _vm.changeUpload(file, index)
      }
    }, [_c("a-icon", {
      attrs: {
        type: "plus"
      },
      on: {
        click: function ($event) {
          return _vm.clickPlus(index);
        }
      }
    })], 1), item.documentDescription ? _c("label", {
      staticClass: "font"
    }, [_vm._v("*" + _vm._s(item.documentDescription))]) : _vm._e(), _c("label", {
      staticClass: "font"
    }, [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "(" + _vm._s(item.documentFormat.join(",")) + ") "), item.documentId != 0 && item.documentTemplateUrl.length != 0 ? _c("a-button", {
      staticClass: "modal-preview",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.onModalPreview(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()], 1)], 1);
  }), _vm.additionalShow ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("材料补充")
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      accept: _vm.uploadAccept,
      remove: file => _vm.removeUploadFile(file),
      "open-file-dialog-on-click": _vm.fileDialog,
      "file-list": _vm.additionalFileList,
      "list-type": "picture-card",
      data: {
        module: "claims"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      preview: file => _vm.handlePreview(file),
      change: file => _vm.changeUpload(file)
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.clickPlus("addition");
      }
    }
  })], 1), _c("label", {
    staticClass: "font"
  }, [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "(" + _vm._s(_vm.plainOptions.join(",")) + ") ")])], 1) : _vm._e(), _c("a-form-item", {
    attrs: {
      "wrapper-col": {
        span: 15,
        offset: 9
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1)], 2) : _vm._e(), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.previewFileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }), _c("preview-list-modal", {
    attrs: {
      previewVisible: _vm.previewListVisible,
      fileList: _vm.modalPreviewList
    },
    on: {
      cancel: function ($event) {
        _vm.previewListVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };